import {ReactNode} from 'react';
import ApiSuspense from '@/shared/components/ApiSuspense';
import {useUserContext} from '@/shared/contexts/UserContext/useUserContext';
import useUserFromConfirmationToken from '../../hooks/useUserFromConfirmationToken';
import UserContext from './UserContext';
import transformCurrentUserToUser from './utils/transformCurrentUserToUser';
import transformUserFromConfirmationTokenToPublicUser from './utils/transformUserFromConfirmationTokenToPublicUser';

export default function UserContextProvider({children}: {children: ReactNode}) {
  const {user} = useUserContext();
  const query = useUserFromConfirmationToken();

  const publicUser = user ? transformCurrentUserToUser(user) : null;
  const publicUserFromConfirmationToken = query?.data?.data
    ? transformUserFromConfirmationTokenToPublicUser(query.data.data)
    : null;

  const element = (
    <UserContext.Provider value={publicUser ?? publicUserFromConfirmationToken}>
      {children}
    </UserContext.Provider>
  );

  if (query) {
    const isTokenQueryPending = query.isPending && query.fetchStatus !== 'idle';

    return (
      <ApiSuspense
        apiQueryStatus={{
          isPending: isTokenQueryPending,
          isError: false,
          isIdle: query.fetchStatus === 'idle'
        }}
      >
        {() => element}
      </ApiSuspense>
    );
  } else {
    return element;
  }
}
